import { FC } from 'react'
import s from './RestaurantFilters.module.sass'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import ContentLoader from '@shared/lib/components/SkeletonContentLoader'
import {
  SKELETON_FOREGROUND_COLOR,
  SKELETON_MAIN_COLOR,
  SKELETON_SPEED,
  SKELETON_STYLES,
} from '@shared/consts/skeleton'

type Props = {
  className: string
}

const Skeleton: FC<Props> = ({ className = '' }) => {
  return (
    <BlockBoundary>
      <ContentLoader
        speed={SKELETON_SPEED}
        backgroundColor={SKELETON_MAIN_COLOR}
        foregroundColor={SKELETON_FOREGROUND_COLOR}
        style={SKELETON_STYLES}
        id={'skeleton-filters'}
        className={`${s.skeleton} ${className}`}>
        <rect x='0' y='0' rx='24' ry='24' width='100%' height='100%' />
      </ContentLoader>
    </BlockBoundary>
  )
}

export default Skeleton
